module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-multy-select-item",
    attrs: {
      "data-isitem": "true"
    }
  }, [_c('div', {
    staticClass: "icon",
    class: {
      'selected': _vm.$props.selected
    },
    on: {
      "click": _vm.select
    }
  }), _c('div', {
    staticClass: "label",
    on: {
      "click": _vm.selectOne
    }
  }, [_vm._v(_vm._s(_vm.$props.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97a2c080","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZMultySelectItem.vue
// module id = 1222
// module chunks = 0